<div class="aa-input-general gap-1 flex flex-col">
  <mat-label
    class="px-3 truncate"
    [title]="label | translate"
    [ngClass]="hasErrorState ? 'text-(--comp-input-label-error)' : 'text-(--comp-input-label-normal)'"
  >
    {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
  </mat-label>

  <mat-form-field appearance="outline" class="w-full input-mat-form-field">
    @if (multiple) {
      <mat-select 
      [formControl]="getInputGeneral" 
      [placeholder]="placeholder | translate" 
      multiple 
      (selectionChange)="selectionChange.emit($event)">
        @for (item of arrayData; track item) {
          <mat-option
            [value]="inputSelect.value === '' ? item : getNestedProperty(item, inputSelect.value)"
            >{{ translateOptions ? (getOptionLabel(item) | translate) : getOptionLabel(item) }}</mat-option
          >
        }
      </mat-select>
    } @else {
      <mat-select
      [formControl]="getInputGeneral"
      [placeholder]="placeholder | translate"
      (selectionChange)="selectionChange.emit($event)"
    >        @for (item of arrayData; track item) {
          <mat-option
            [value]="inputSelect.value === '' ? item : getNestedProperty(item, inputSelect.value)"
            >{{ translateOptions ? (getOptionLabel(item) | translate) : getOptionLabel(item) }}</mat-option
          >
        }
      </mat-select>
    }

    @if (
      formControlGeneral && formControlGeneral.errors && formControlGeneral.hasError('required')
    ) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (
      formControlGeneral && formControlGeneral.errors && formControlGeneral.errors['errorGeneral']
    ) {
      <mat-error>
        {{ formControlGeneral.errors['errorGeneral'] }}
      </mat-error>
    }
  </mat-form-field>
</div>
